// Module
var code = "<section class=\"page-content\"> <h1 data-page-title class=\"page-content-title\"></h1> <div data-page-content></div> </section>";
// Exports
export default code;